<template>
    <div class="middle-box text-center loginscreen animated fadeInDown">
        <div>
            <div class="pt-4">

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="154.11 222.14 510 156"><path shape-rendering="geometricPrecision" d="M171.14 324.54h13.6s15.03-26.34 31.23-48.16c10.1-13.6 18.14-23.57 28-31.96 7.2-6.12 11.16-9.67 20.83-10.84 7.15-.87 5.48 6.83 5.39 7.68-.1.86-2.24 8.06-6.58 18L247.18 297l-18.42 42.5 12.41 5.1 32.37-78.51 5.53-13.58s7.48-15.9-1.02-19.99c-7.71-3.7-18.4-.98-23.1 1.25 0 0-9.71 4.81-19.47 14.5s-24.84 29.38-33.13 41.89c-8.29 12.5-13.33 20.68-13.33 20.68s12.9-26.7 18.69-40.14c5.78-13.44 8.64-26.43 8.42-29.52-.22-3.1-.28-8.3-6.98-9.51-4.96-.9-13.8 1.25-19.2 4.67-5.42 3.41-15.24 11.55-23.3 21.65-5.18 6.5-4.18 5.53-4.18 5.53l7.48 7.82s16.8-28.78 28.14-35.5c2.96-1.74 6.37-2.96 8.57-1.33 2.19 1.63-.48 7.85-.67 8.44-.2.6-1.18 4.8-9.74 24.24l-18.5 42.03-6.61 15.33zm118.96-10.82c5.31-1.26 14.5-4.05 19.2-5.9s7.96-5.57 7.94-9.13c-.02-3.55-3.14-5.36-5.1-6.28-.73-.35-13.15-4.52-29.1 3.31s-15.38 17.1-14.81 19.86c.68 3.31 2.48 9.16 15.73 9.41 13.25.26 27.25-8.27 27.25-8.27l-1.2-1.53s-3.96 1.64-6.7 2.83c-2.74 1.2-10.25 3.76-16.9 3.27-6.64-.5-6.31-5.76-6.31-5.76s4.7-.55 10-1.81zm13.1-20.13c4.3 0 5.69 2.98 5.19 4.66-.5 1.68-1.97 7.14-13.27 11.04-11.3 3.9-15.02 3.69-15.02 3.69s6.08-19.4 23.1-19.4zm41.85-1.23c-17.82 3.98-23.01 14.92-22.98 18.69.08 11.42 11.48 13.95 20.73 13.95 15.39 0 30.78-10.4 30.78-20.39 0-9.1-11.47-16.06-28.53-12.25zm16.21 7.8c-1.14 6.38-6.18 22-19.87 22.35-3.48.1-7.64-1.26-6.33-8.13 1.3-6.88 6.25-14.84 9.92-17.26 3.67-2.43 4.63-3.5 9.14-3.5 1.34 0 1.77.14 1.77.14s6.52.04 5.37 6.4zm167.36-8.6l-1.87 4.08s-6.72-3.09-11.12-1.9c-4.4 1.2-10.81 3.32-17.34 14.13-3.3 5.45-2.6 9.97-1.1 10.99 1.5 1.02 4.4 3.31 10.07 0 8.76-5.12 14.74-12.23 19.01-18.6 4.27-6.39 5.75-8.2 5.75-8.2l13.26-.33s-6.4 13.44-8.13 16.78c-3.07 5.97-4.66 9.73-4.66 9.73s-1.87 3.1 3.22 3.1c1.91 0 6.64-2.36 8.87-3.57l4.44-2.41 1.35 1.7s-11.8 8.08-20.84 7.83c-6.33-.17-9.71-3.16-9.06-5.72 1.42-5.53 5.21-13.32 5.21-13.32s-8.02 10.88-14.23 14.01c-6.22 3.13-9.94 5.59-17.1 5.04-7.15-.55-12.3-3.66-11.64-10.66 0 0-.26-5.02 4.7-10.16 4.97-5.14 11.24-8.42 17.24-10.53s13.64-2.95 17.24-2.7c3.6.25 6.73.71 6.73.71zm40.28.34l13.26-.85-10.18 25.58s-3.06 6.14 2.29 5.06 9.47-4.18 10.58-5.11c1.1-.93 2.41-1.56 2.41-1.56l2.21 1.36s-11 9.03-22 8.6c-2.82-.12-8.73-1.12-8.73-4.53 0-2.06 1.04-5.35 2.13-8.18 1.08-2.82 8.03-20.37 8.03-20.37zm5.2-21.33c.4-1.4 3.88-8.21 9.3-7.46 6.6.91 5.02 8.62 4.65 10.03-1.41 5.35-6.73 8.82-9.47 8.6-2.74-.22-6.67-3.4-5.13-8.92.42-1.52.5-1.69.65-2.25zm81.8-32.86c-.03-3.18-1.54-6.5-5.6-6.65-4.07-.15-9.29 3.75-14.17 7.9-4.88 4.14-11.98 16.26-18.5 27.24-6.5 10.98-20.34 44.57-20.34 44.57l-1.94 5.4c-.82 2.5.33 4.62.33 4.62.7 2.13.93 3.77 6.95 4.2 10.14.71 21.86-7.09 21.86-7.09l-1.24-1.47-5.72 2.83c-.86.42-5.58 2.67-9.34 2.27-3.77-.4-2.55-5.08-2.38-6.11.17-1.04 2.5-7.72 4.5-12.77 2-5.06 2.65-5.46 2.65-5.46s1.54-1.16 2.32-1.63c.78-.47 7.29-5.61 15.7-12.92 8.4-7.3 14.8-16.68 19.7-24.23 4.89-7.55 5.25-17.51 5.22-20.7zm-2.8 3.04c-.07.96-.6 9.09-5.34 17.27-4.73 8.19-7.37 12.02-15.99 20.17-8.62 8.14-16.63 14.56-16.63 14.56s10.84-21.5 17.7-32.93c6.86-11.42 12.92-20.6 12.92-20.6s2.53-4.5 5.69-4.49c2.33.02 1.71 5.06 1.64 6.02zM188.4 356.94c.97-.17 2.34-.3 4.26-.3 1.94 0 3.35.38 4.28 1.15a3.98 3.98 0 0 1 1.47 3.2c0 1.39-.44 2.54-1.26 3.3-1.08 1-2.7 1.48-4.55 1.48a5.4 5.4 0 0 1-1.08-.09v5h-3.12v-13.74zm3.12 6.32c.27.07.6.09 1.06.09 1.67 0 2.7-.85 2.7-2.26 0-1.28-.86-2.04-2.45-2.04a5.7 5.7 0 0 0-1.3.1v4.11zm34.48-6.3a24.6 24.6 0 0 1 4.19-.31c2.07 0 3.51.3 4.5 1.11a3.5 3.5 0 0 1 1.3 2.92 3.69 3.69 0 0 1-2.45 3.4v.07c.97.4 1.5 1.3 1.86 2.59.43 1.59.84 3.4 1.11 3.94h-3.22c-.2-.4-.56-1.53-.95-3.24-.4-1.76-1-2.22-2.3-2.23h-.93v5.47H226v-13.72zm3.11 5.97h1.24c1.58 0 2.5-.78 2.5-2 0-1.26-.86-1.92-2.31-1.92-.76 0-1.2.04-1.43.1v3.82zm39.37 7.98c-4.12 0-6.56-3.12-6.56-7.09 0-4.17 2.7-7.3 6.78-7.3 4.28 0 6.62 3.2 6.62 7.05 0 4.6-2.75 7.34-6.82 7.34h-.02zm.14-2.5c2.13 0 3.35-2 3.35-4.73 0-2.5-1.18-4.65-3.35-4.65s-3.39 2.1-3.39 4.71c0 2.63 1.26 4.67 3.37 4.67h.02zm33.18-11.66h8.5v2.59h-5.35v3.18h5v2.56h-5v5.6h-3.15v-13.93zm43.56 8.05h-5.12v3.3h5.72v2.58h-8.86v-13.93h8.57v2.59h-5.43v2.89h5.12v2.56zm28.44 2.66c.82.43 2.15.87 3.49.87 1.45 0 2.21-.6 2.21-1.53 0-.85-.66-1.36-2.33-1.94-2.32-.83-3.85-2.11-3.85-4.16 0-2.37 2-4.17 5.27-4.17 1.6 0 2.73.3 3.56.7l-.7 2.52a6.51 6.51 0 0 0-2.9-.66c-1.36 0-2.02.64-2.02 1.34 0 .9.76 1.29 2.58 1.99 2.46.9 3.6 2.19 3.6 4.17 0 2.34-1.78 4.32-5.6 4.32-1.6 0-3.17-.43-3.95-.87l.64-2.58zm36.74 0c.83.43 2.15.87 3.5.87 1.44 0 2.2-.6 2.2-1.53 0-.85-.66-1.36-2.33-1.94-2.31-.83-3.85-2.11-3.85-4.16 0-2.37 2.01-4.17 5.28-4.17 1.59 0 2.72.3 3.55.7l-.7 2.52a6.52 6.52 0 0 0-2.9-.66c-1.36 0-2.02.64-2.02 1.34 0 .9.77 1.29 2.58 1.99 2.46.9 3.6 2.19 3.6 4.17 0 2.34-1.78 4.32-5.6 4.32a9 9 0 0 1-3.95-.87l.64-2.58zm38.62-10.71v13.93h-3.14v-13.93h3.14zm31.85 14.16c-4.11 0-6.55-3.12-6.55-7.09 0-4.17 2.68-7.3 6.78-7.3 4.27 0 6.61 3.2 6.61 7.05 0 4.6-2.75 7.34-6.82 7.34h-.02zm.14-2.5c2.14 0 3.35-2 3.35-4.73 0-2.5-1.17-4.65-3.35-4.65-2.16 0-3.38 2.1-3.38 4.71 0 2.63 1.26 4.67 3.36 4.67h.02zm31.98 2.28v-13.94h3.68l2.9 5.1a45.46 45.46 0 0 1 2.27 4.78h.04a56.9 56.9 0 0 1-.24-5.83v-4.05h2.89v13.93h-3.3l-2.99-5.37a49.53 49.53 0 0 1-2.41-4.92h-.09c.1 1.86.15 3.82.15 6.1v4.2h-2.9zm40.7-3.59l-.97 3.58h-3.26l4.25-13.93h4.12l4.34 13.93h-3.4l-1.07-3.57h-4zm3.54-2.35l-.87-2.95c-.23-.83-.47-1.89-.68-2.7h-.06c-.2.83-.42 1.9-.63 2.7l-.84 2.95h3.08zm30.03-8h3.15v11.29h5.54v2.64h-8.69v-13.93zm-200.37-32.21h13.6s15.03-26.34 31.23-48.16c10.1-13.6 18.14-23.57 28-31.96 7.2-6.12 11.16-9.67 20.83-10.84 7.15-.87 5.48 6.83 5.39 7.68-.09.86-2.24 8.06-6.58 18L463.07 297c-2.27 5.21-18.42 42.5-18.42 42.5l12.41 5.1 32.37-78.52 5.53-13.58s7.48-15.9-1.03-19.99c-7.7-3.7-18.38-.98-23.1 1.26 0 0-9.7 4.8-19.46 14.49-9.76 9.68-24.84 29.39-33.13 41.89-8.29 12.5-13.33 20.68-13.33 20.68s12.9-26.7 18.68-40.14c5.79-13.44 8.65-26.42 8.43-29.52-.22-3.1-.27-8.29-6.98-9.51-4.96-.9-13.8 1.26-19.2 4.67s-15.24 11.55-23.3 21.65c-5.19 6.5-4.18 5.53-4.18 5.53l7.48 7.82s16.8-28.78 28.14-35.5c2.95-1.74 6.37-2.96 8.56-1.33 2.2 1.63-.47 7.85-.67 8.44-.2.6-1.17 4.8-9.73 24.25l-18.5 42.02-6.61 15.33z"></path></svg>

            </div>
            <h3>Witaj w NeoNail</h3>
            <!-- <p>Perfectly designed and precisely prepared admin theme with over 50 pages with extra new web app views.
            </p> -->
            <p>Zaloguj się</p>
            <form
                class="m-t"
                :class=" { 'sk-loading': loading } "
                role="form"
                @submit.prevent="handleSubmit"
            >
                <div class="sk-spinner sk-spinner-wave">
                    <div class="sk-rect1"></div>
                    <div class="sk-rect2"></div>
                    <div class="sk-rect3"></div>
                    <div class="sk-rect4"></div>
                    <div class="sk-rect5"></div>
                </div>
                <div
                    class="form-group"
                    :class="{'has-error': errors.has('email')}"
                >
                    <input
                        type="email"
                        class="form-control"
                        placeholder="E-mail"
                        v-model="credentials.email"
                        v-validate="'required'"
                        name="email"
                    >
                    <small
                        v-show="errors.has('email')"
                        class="text-danger"
                    >
                        {{ $t( 'field_required' ) }}
                    </small>
                </div>
                <div
                    class="form-group"
                    :class="{'has-error': errors.has('password')}"
                >
                    <input
                        type="password"
                        class="form-control"
                        placeholder="Hasło"
                        v-model="credentials.password"
                        v-validate="'required'"
                        name="password"
                    >
                    <small
                        v-show="errors.has('password')"
                        class="text-danger"
                    >
                        {{ $t( 'field_required' ) }}
                    </small>
                </div>
                <button
                    type="submit"
                    class="btn btn-primary block full-width m-b"
                >
                    Login
                </button>

                <router-link to="/remind">
                    <small>Zapomniałeś hasła?</small>
                </router-link>
                <!-- <p class="text-muted text-center"><small>Do not have an account?</small></p>
                <a class="btn btn-sm btn-white btn-block" href="register.html">Create an account</a> -->
            </form>
            <p class="m-t"> <small>Copyright by COSMO GROUP SP. Z O.O. SP. K. © {{ $moment().format('YYYY') }}</small> </p>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'login',
    data() {
        return {
            loading: false,
            credentials: {
                email: '',
                password: ''
            }
        }
    },
    beforeCreate() {
        document.querySelector( 'body' ).classList.add( 'gray-bg' )
    },
    computed: {
        ...mapGetters( 'auth', [
            'authenticating',
            'authenticationError',
            'authenticationErrorCode'
        ] )
    },
    methods: {
        ...mapActions( 'auth', [
            'signin'
        ] ),
        ...mapActions( 'users', [
            'setUserData'
        ] ),
        handleSubmit() {
            this.$validator.validateAll().then( result => {
                if ( result ) {
                    this.loading = true
                    this.signin( {
                        email: this.credentials.email,
                        pass: this.credentials.password,
                        redirect: false
                    } ).then( resp => {
                        if ( resp ) {
                            this.show_logo = false
                            this.$forceUpdate()
                            this.setUserData()
                            this.$nextTick( () => {
                            // setTimeout( () => {
                                this.$router.push( { name: 'dashboard' } )
                            // }, 2000 )
                            } )
                        } else {
                            this.loading = false
                            this.$toastr.error( 'Błąd logowania' )
                        }
                    } )
                    .catch( err => {
                        console.log( err )
                    } )
                }
            } )
        }
    }
}
</script>

